export enum AvailableTabs {
  QuickQuote = 'quickQuote',
  TrucksList = 'trucksList',
  LoadBuilding = 'loadBuilding',
  CarrierQuoting = 'carrierQuoting',
  // If tabs are added, update setDefaultTabByFeatureFlagsHierarchy
}
